var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.571 7.62l-13.978 13.901c-0.366 0.36-0.593 0.86-0.593 1.413 0 0.003 0 0.005 0 0.008v-0c-0 0.002-0 0.005-0 0.008 0 0.553 0.227 1.053 0.593 1.413l0 0c0.368 0.364 0.873 0.588 1.431 0.588s1.064-0.225 1.432-0.589l-0 0 12.544-12.467 12.544 12.472c0.366 0.364 0.872 0.59 1.429 0.59 1.114 0 2.018-0.898 2.027-2.010v-0.001c-0.001-0.551-0.23-1.048-0.597-1.403l-0.001-0.001-13.969-13.905c-0.366-0.367-0.872-0.594-1.431-0.594s-1.065 0.227-1.431 0.594l-0 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronTop);
export default __webpack_public_path__ + "static/media/chevron-top.8890008a.svg";
export { ForwardRef as ReactComponent };